import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {}
const qsAll = {
  swipers: 'data-flagship-swiper',
}

export const setupFlagshipHero = () => {
  cacheDom(dom, qs, qsAll)
  dom.swipers.forEach((swiperElement) => {
    new Swiper(swiperElement, {
      speed: 500,
      effect: 'fade',
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    })
  })
}